import React from 'react';
import { Card, Progress, Typography, Button, Row, Col } from 'antd';

import { BulbOutlined } from '@ant-design/icons';
const { Title, Text } = Typography;

interface TipsCarouselProps {
  tips: string[];
}

const tips = [
  'Tip 1: Keep old credit accounts active.',
  'Tip 2: Pay CC and other bills time to time',
  'Tip 3: Great Going on your payments',
];

const Tips: React.FC = () => {
  return (
    <div style={{ paddingTop: '10px' }}>
      <Title level={5}>Tips For You</Title>
      <div
        style={{
          display: 'flex',
          gap: 10,
          padding: '10px',
          flexWrap: 'wrap',
        }}
      >
        {tips.map((tip, index) => (
          <div
            key={index}
            style={{
              display: 'inline-block',
              marginRight: '10px',
            }}
          >
            <Card
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                height: '50px',
                padding: '10px',
                border: '2px solid grey',
              }}
            >
              <BulbOutlined
                style={{
                  color: 'black',
                  position: 'absolute',
                  left: 4,
                  top: 0,
                  width: '100%',
                  height: '100%',
                }}
              />
              <BulbOutlined
                style={{
                  color: 'yellow',
                  position: 'absolute',
                  left: 4,
                  top: 0,
                  width: 'calc(100% - 4px)',
                  height: 'calc(100% - 4px)',
                  clipPath: 'inset(1px 1px 1px 1px)',
                }}
              />
              <span>{tip}</span>
            </Card>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Tips;
